import { resourceExplorerProviderByProviderPossibleFiltersSelector } from "../resourceExplorerProviderByProviderPossibleFiltersSelector";
import { RootState } from "../../../../../store";

export const gcpPossibleFiltersSelector = (state: RootState) => {
  return resourceExplorerProviderByProviderPossibleFiltersSelector({
    provider: "gcp",
  })(state)?.data;
};
